import { useEffect, useState } from 'react';

import organisationsAPI from '@/api/organisations';
import Spinner from '@/components/Icons/Spinner';
import { InfoPanelContainer } from '@/components/InfoPanelContainer';
import InfoPanelDivider from '@/components/InfoPanelDivider';
import InputInline from '@/components/InputInline';
import { MESSAGES } from '@/constants/messages-en';

import { ErrorAlert, SuccessAlert } from '../Alert';

interface IColourSettings {
  organisationSettingID: number | undefined;
  organisationColorSetting: string | undefined;
}
const colourSettingValue = [
  {
    title: 'CMYK',
    value: 'CMYK',
  },
  {
    title: 'RGB',
    value: 'RGB',
  },
];

const ColourSettings: React.FC<IColourSettings> = ({
  organisationSettingID,
  organisationColorSetting,
}) => {
  const [colourSettings, setColourSettings] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string>('');
  const [error, setError] = useState(false);

  useEffect(() => {
    setColourSettings(organisationColorSetting || 'CMYK');
  }, [organisationColorSetting]);

  return (
    <>
      <InfoPanelDivider />
      {success !== '' && <SuccessAlert message={success} />}
      {error && <ErrorAlert message={MESSAGES.error.generic} />}

      <InfoPanelContainer
        title="Colour settings"
        description="Please select which colour mode you would like us to print your physical cards."
      >
        <div className="flex justify-between items-center w-ful h-full">
          <p className="text-sm leading-5 font-medium font-poppins text-gray-900">
            Printing setting
          </p>
          {!loading ? (
            <InputInline
              type="radio"
              data={colourSettings}
              setData={setColourSettings}
              divideText="or"
              wrapperClassName="flex items-center gap-5"
              onChange={(data: any, { error, complate }) => {
                setLoading(true);
                organisationsAPI
                  .updateOrganisationAdminSettings({
                    organisationSettingID,
                    body: {
                      colour: data,
                    },
                  })
                  .then(() => setSuccess('Success updated colour setting'))
                  .catch(e => {
                    setError(true);
                    setColourSettings(organisationColorSetting || 'CMYK');
                  })
                  .finally(() => setLoading(false));
              }}
              setting={colourSettingValue}
            />
          ) : (
            <Spinner />
          )}
        </div>
      </InfoPanelContainer>
      <InfoPanelDivider />
    </>
  );
};

export default ColourSettings;
